import { createStore } from 'vuex'
import Security from '@/store/modules/security'

export default createStore({
    modules: {
        security: Security
    }
});